
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-57e0d1d5&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./TopMenu.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TopMenu.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-57e0d1d5!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TopMenu.vue"),
  /* scopeId */
  "data-v-57e0d1d5",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/TopMenu.vue
// module id = 298
// module chunks = 1